export type CalculateFestivalCo2 = {
  scoreLetter: string; // A B C D E
  score: number; // 43 teCO2
  scoreKgeCO2: number; // 43 000 KgeCO2
  kgeCO2ByParticipant: number;
  completion: number;
  sectors: {
    artists: {
      completion: number;
      score: number;
      categories: {
        mobility: { score: number };
        catering: { score: number };
        accommodation: { score: number };
        cargo: { score: number };
      };
    };
    team: {
      completion: number;
      score: number;
      categories: {
        mobility: { score: number };
        catering: { score: number };
        accommodation: { score: number };
      };
    };
    public: {
      completion: number;
      score: number;
      categories: {
        mobility: { score: number };
        catering: { score: number };
        accommodation: { score: number };
        digital: { score: number };
      };
    };
    site: {
      completion: number;
      score: number;
      categories: {
        energy: { score: number };
        water: { score: number };
        equipment: { score: number };
        waste: { score: number };
        cargo: { score: number };
        building: { score: number };
      };
    };
  };
};

export const EMPTY_CALCULATE_FESTIVAL_CO2: CalculateFestivalCo2 = {
  scoreLetter: '-',
  score: 0,
  scoreKgeCO2: 0,
  kgeCO2ByParticipant: 0,
  completion: 0,
  sectors: {
    artists: {
      completion: 0,
      score: 0,
      categories: {
        mobility: { score: 0 },
        catering: { score: 0 },
        accommodation: { score: 0 },
        cargo: { score: 0 },
      },
    },
    team: {
      completion: 0,
      score: 0,
      categories: {
        mobility: { score: 0 },
        catering: { score: 0 },
        accommodation: { score: 0 },
      },
    },
    public: {
      completion: 0,
      score: 0,
      categories: {
        mobility: { score: 0 },
        catering: { score: 0 },
        accommodation: { score: 0 },
        digital: { score: 0 },
      },
    },
    site: {
      completion: 0,
      score: 0,
      categories: {
        energy: { score: 0 },
        water: { score: 0 },
        equipment: { score: 0 },
        waste: { score: 0 },
        cargo: { score: 0 },
        building: { score: 0 },
      },
    },
  },
};
